import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconInterpretationS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M 4 0 V 4 H 0 V 2.5 C 0 1.1193 1.1193 0 2.5 0 H 4 Z M 9 5 H 5 V 9 H 9 V 5 Z M 10 10 H 14 V 11.5 C 14 12.8807 12.8807 14 11.5 14 H 10 V 10 Z M 5 1 H 11.5 C 12.3284 1 13 1.6716 13 2.5 V 9 H 14 V 2.5 C 14 1.1193 12.8807 0 11.5 0 H 5 V 1 Z M 2.5 13 H 9 V 14 H 2.5 C 1.1193 14 0 12.8807 0 11.5 V 5 H 1 V 11.5 C 1 12.3284 1.6716 13 2.5 13 Z" />
    </svg>
  )
}

export const IconInterpretation = createIcon({
  l: IconInterpretationS,
  m: IconInterpretationS,
  s: IconInterpretationS,
  xs: IconInterpretationS,
  name: 'IconInterpretation',
})
